import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ApplicationsConfiguredSettingsEffects } from './applications-configured-settings.effects';
import { applicationsConfiguredSettingsReducer } from './applications-configured-settings.reducer';

export const provideApplicationsConfiguredSettingsStore = () => [
  provideState('applicationsConfiguredSettings', applicationsConfiguredSettingsReducer),
  provideEffects([ApplicationsConfiguredSettingsEffects]),
];
